import { InitialState } from "./types"
import { ConfigurationDto } from "../models"
import { PatchPayload } from "../services/types"

export const stateHandler = (state: InitialState) => {
    return {
        fetch: (): InitialState => {
            return {
                ...state,
                isFetching: true,
            }
        },
        fetchSuccess: (res: ConfigurationDto) => {
            return {
                isFetching: false,
                isLoaded: true,
                id: res.id,
                ...res.attributes,
            }
        },
        update: (payload: PatchPayload) => {
            return {
                ...state,
                ...payload,
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/configuration/reducers/handler.ts